import { Injectable } from '@angular/core';
import { NgbDate, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { DateService, DateStruct } from 'outshared-lib';

/**
 * Example of a Native Date adapter
 */
@Injectable()
export class DateNativeAdapter extends NgbDateAdapter<string> {

    constructor(private readonly dateService: DateService) {
        super();
    }

    fromModel(tmpDate: string): DateStruct {
        if (!tmpDate || !this.dateService.isValid(tmpDate)) {
            return null;
        }
        const date = this.dateService.add(12, 'hour', tmpDate);
        return this.dateService.toNgbDateStruct(date);
    }

    toModel(date: NgbDate): string {
        if (!date) {
            return null;
        }
        const dateStruct = {year: date.year, month: date.month, day: date.day};
        const newDate = this.dateService.add(12, 'hour', date);
        return this.dateService.format(newDate, 'YYYY-MM-DD');
    }
}
